import React from 'react'
import { VIEMO_QUERY_PARAMS, VIMEO_URL } from '../../constants/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Overlay from '../Overlay/Overlay';

const ViemoVideo = ({ setOnClick, videoId }) => {
    const handleClose = (e) => {
        e.stopPropagation();
        setOnClick(false);
    }

    const url = `${VIMEO_URL}/${videoId}?${VIEMO_QUERY_PARAMS}&autoplay=1`;

    const viemoVideoHeaderStyle = {
        display: 'flex',
        justifyContent: 'flex-end',
        background: '#fff',
        padding: '20px',

    }

    const viemoVideoStyle = {
        width: '640px',
        height: '360px',
    };

    return (
        <Overlay onClick={handleClose}>
            <div>
                <div style={viemoVideoHeaderStyle}>
                    <FontAwesomeIcon style={{cursor: 'pointer'}} icon={faTimes} size='2x'/>
                </div>
                <iframe 
                    style={viemoVideoStyle}
                    src={url}
                    frameBorder={0}
                    allow="autoplay; fullscreen; picture-in-picture"
                    title={"CleverAlpha Video"}
                    allowFullScreen=""
                />
            </div>
        </Overlay>
       
    )
}

export default ViemoVideo